// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"7872b24439c176e6566a","678":"468b172cc5555c8c0b8f"}[chunkId] + ".js";
};